<template>
  <div class="block">
    <h4>Selecciona tu tipo de contactos</h4>
    <p v-if="origin === 'email'">
      Solo se considerarán aquellos contactos que cuenten con correos electrónicos agregados a su
      información personal. Se enviará a todos los correos asociados al contacto.
    </p>
    <div class="block block--light info" v-if="!isIvrReturn">
      <InfoCircleOutlined class="icon" />
      <span class="info--text" action="Cerrar">
        Elige si quieres ver contactos que ya han sido gestionados en {{ ProductName }} y cuentan
        con resultados de tipificaciones, contactos nuevos que aún no han sido gestionados, o todos
        los contactos sin importar su estado de gestión.
      </span>
    </div>
    <div class="separator"></div>
    <a-radio-group v-model:value="_coverage">
      <a-radio
        class="radio"
        :class="{ 'radio_description': isIvrReturn }"
        :value="1"
      >
        Contactos gestionados
        <div class="radio-description" v-if="isIvrReturn">
          Ver contactos que ya han sido gestionados en Beex Contact Center y cuentan con resultados de tipificaciones.
        </div>
      </a-radio>

      <a-radio
        class="radio"
        :class="{ 'radio_description': isIvrReturn }"
        :value="2"
      >
        Contactos sin gestionar
        <div class="radio-description" v-if="isIvrReturn">
          Ver contactos nuevos que aún no han sido gestionados.
        </div>
      </a-radio>
      <a-radio
        class="radio"
        :class="{ 'radio_description': isIvrReturn }"
        :value="3"
      >
        Todos los contactos
        <div class="radio-description" v-if="isIvrReturn">
          Ver todos los contactos sin importar su estado de gestión.
        </div>
      </a-radio>
    </a-radio-group>

    <dashed-button style="margin-top: 10px" :disabled="disabled" @onClick="handleOpenDrawer">
      <span v-if="disabled"> Sin filtros para contactos </span>
      <span v-else> {{ clientsFilterQuantityText }} </span>
    </dashed-button>

    <client-filters-drawer
      ref="drawer"
      :value="visible"
      @update:value="visible = $event"
      :isShowDrawer="isShowDrawer"
      @hideDrawer="handleHideDrawer"
    />
  </div>
</template>

<script>
import ClientFiltersDrawer from "@/app/strategies/components/drawers/ClientFiltersDrawer.vue";
import DashedButton from "@/app/strategies/components/buttons/DashedButton.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { ProductName } from "@/app/shared/utils/constants";
import { TypeStrategy } from "@/@types/strategies/modalStrategy";

export default {
  components: {
    ClientFiltersDrawer,
    DashedButton,
    InfoCircleOutlined,
  },
  props: {
    coverage: {
      required: true,
      type: Number,
    },
    origin: {
      type: String,
      required: false,
    },
    typeStrategy: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      visible: false,
      isShowDrawer: false,
      ProductName,
      TypeStrategy,
    };
  },
  computed: {
    _coverage: {
      get() {
        return this.coverage;
      },
      set(value) {
        this.$emit("coverage", value);
      },
    },
    disabled() {
      return !(this._coverage === 1);
    },
    counter() {
      return this.$store.getters["getStrategyClientFiltersCount"];
    },
    clientsFilterQuantityText() {
      if (this.counter == 0) return "Seleccionar filtros de contactos gestionados";
      if (this.counter == 1)
        return `Se ha agregado un filtro de contactos gestionados, seguir editando aquí`;
      return `Se han agregado ${this.counter} filtros de contactos gestionados, seguir editando aquí`;
    },
    isIvrReturn() {
      return this.typeStrategy === TypeStrategy.IvrReturn;
    },
  },
  methods: {
    handleOpenDrawer() {
      this.$refs.drawer.initDrawer();
      this.visible = true;
      this.isShowDrawer = true;
    },
    handleHideDrawer() {
      this.isShowDrawer = false;
      this.visible = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.block
  padding: 28px 12px 20px 12px
  margin: 12px 0
  border: 1px solid $gray-6
  border-radius: 8px

  &--light
    border: 1px solid #dcdcdc
    color: $gray-7
    padding: 8px 12px
    margin: 4px 0 12px 0

.info
  display: flex

  &--text
    font-size: 12px

.radio
  display: block
  height: 28px
  line-height: 28px
  user-select: none
.radio_description
  height: 55px
  line-height: 16px
  :deep(.ant-radio)
    margin-top: 2px
  .radio-description
    margin-top: 4px
    font-size: 12px
    color: $gray-8
    line-height: 16px
    margin-left: 28px
.separator
  margin-bottom: 10px

.icon
  margin: 3px 6px 0 0
</style>
